import { createContext, useContext } from "react";

type PersonneAVerifierContextValue = {
  selectedPersonneId?: string;
  onPersonneSelected: (id: string) => void;
};

export const PersonneAVerifierContext =
  createContext<PersonneAVerifierContextValue | null>(null);

export function usePersonneContext() {
  const context = useContext(PersonneAVerifierContext);
  if (!context)
    throw new Error("usePersonneContext must be used within AxePageTemplate");
  return context;
}
